export default __webpack_public_path__ + "static/media/alarm-icon.8509a229.svg";